import { render } from "./ViewSessionPage.vue?vue&type=template&id=228a7eac&ts=true"
import script from "./ViewSessionPage.vue?vue&type=script&lang=ts"
export * from "./ViewSessionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__